export default {"src":"/_next/static/media/Payment.73408431.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};